import React from "react";
import {
  AreaChart,
  Area,
  BarChart,
  Bar,
  LineChart,
  Line,
  ComposedChart,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
  ReferenceLine,
  ReferenceArea,
  Legend,
} from "recharts";
import {
  RouteIcon,
  TrendingUp,
  Users,
  Activity,
  Crosshair,
  Sparkles,
  Trophy,
  ClipboardList,
  NotebookPen,
  Plus,
  Pencil,
  Trash2,
  ChevronDown,
  ChevronUp,
  Search,
  ArrowUpRight,
  ArrowDownRight,
  Download,
  Calendar,
  Clock,
  CheckCircle2,
  XCircle,
  AlertTriangle,
  Info,
  Zap,
  Brain,
  BarChart3,
  X,
  UserCheck,
  Building2,
  HeartHandshake,
  CalendarDays,
  CalendarCheck,
  Stethoscope,
  FlaskConical,
  Headphones,
  Receipt,
  Smartphone,
  Globe,
  HeartPulse,
  MessageSquare,
  ShoppingCart,
  CircleAlert,
  Lightbulb,
  TrendingDown,
  ScanSearch,
  Filter,
  Bell,
  Send,
  PanelLeftClose,
  PanelLeft,
  Archive,
  Link as LinkIcon,
  ExternalLink,
  History,
  Heart,
  MessageCircle,
  Share2,
  Upload,
  MapPin,
  ThumbsUp,
  ThumbsDown,
  EyeOff,
  Eye,
  Phone,
  Mail,
} from "lucide-react";
import * as S from "./_shared";
export default function CooperacaoView({ ctx }) {
  const {
    ACOES_INIT,
    AcaoCard,
    AcaoDetalhe,
    AcaoModal,
    C,
    CES_COLS,
    CES_ETAPAS_NAMES,
    CES_TREND,
    CIDADES_COBERTURA,
    COOP_PLANOS_MOCK,
    CSAT_COLS,
    CSAT_ETAPAS_NAMES,
    CSAT_TREND,
    Card,
    DRIVERS_CANONICOS,
    DRIVER_TO_PILLAR,
    DistBar,
    ESCALA,
    ETAPA_DRIVER_AFFINITY,
    ETAPA_HIST,
    EtCard,
    EvaChat,
    EvaChatHistory,
    EvaInsights,
    F,
    HIST_ACOES_POR_ETAPA,
    JCFG,
    JICONS,
    LOGO,
    MESES_HIST,
    META_NPS,
    MUDANCAS_DESDE_ULTIMA_VISITA,
    MiniSparkline,
    NPSAnchor,
    PC,
    PDFExportModal,
    PER,
    PER_DEFAULT_LABELS,
    PER_OPTIONS,
    PILLAR_COLORS,
    PeriodPill,
    PeriodPillBig,
    SC,
    SHORT,
    SUCESSO_BADGES,
    SUCESSO_LEVELS,
    SYS_NPS,
    Section,
    TREND_BY_AGRUP,
    TT,
    Tag,
    ULTIMA_VISITA,
    UNIMED,
    VERBATINS_POR_ETAPA,
    Z_CX,
    Zonas,
    _META_CES_TR,
    _META_CSAT_TR,
    _META_NPS_TR,
    _SYS_CES_TR,
    _SYS_CSAT_TR,
    _SYS_NPS_TR,
    diasRest,
    etSt,
    exportPDF,
    fmtDt,
    getDriverInfo,
    getDriversForEtapa,
    getPilarOf,
    getSucessoStats,
    moe,
    pctChk,
    safeGanhoPp,
    tempoRelativo,
    todayStr,
  } = S;
  const {
    DATA,
    SAUDACAO_EVA,
    acaoSel,
    acoes,
    adicionarComentario,
    agrupT,
    atualizarMensagensChatEva,
    bulkApplyEtapas,
    bulkApplyGerais,
    bulkOpen,
    bulkPct,
    busca,
    cidadesAtivas,
    compartilharPlano,
    concluirWizard,
    coopBusca,
    coopComentariosAbertos,
    coopCurtidas,
    coopDriverFilter,
    coopEtapaFilter,
    coopNovoComentario,
    coopPlanos,
    d,
    db,
    dd,
    de,
    delAcao,
    desocultarNotif,
    dj,
    driverSortMode,
    ds,
    editandoMeta,
    editandoMetaEt,
    etapaDriversFilter,
    etapaHistSel,
    etapaSel,
    evaChatAtivoId,
    evaChats,
    excluirChatEva,
    filtroCidadeAberto,
    filtroResp,
    filtroSt,
    gamificacaoOn,
    hiddenLines,
    historicoEvaVisivel,
    jorGraf,
    marcarComoLida,
    marcarTodasLidas,
    metas,
    metasCardOpen,
    metasEtapas,
    modal,
    mostrarOcultos,
    naoLidas,
    nenhumaCidade,
    notifModalFiltro,
    notifModalOpen,
    notifOpen,
    notifs,
    notifsOcultas,
    notifsVisiveis,
    novoChatEva,
    ocultarNotif,
    openPublishWizard,
    pB,
    pD,
    pE,
    pJ,
    pS,
    per,
    periodoCustom,
    periodoG,
    respDropOpen,
    segHistMode,
    segIndicador,
    selecionarChatEva,
    setAcaoSel,
    setAcoes,
    setAgrupT,
    setBulkApplyEtapas,
    setBulkApplyGerais,
    setBulkOpen,
    setBulkPct,
    setBusca,
    setCidadesAtivas,
    setConcluirWizard,
    setCoopBusca,
    setCoopComentariosAbertos,
    setCoopCurtidas,
    setCoopDriverFilter,
    setCoopEtapaFilter,
    setCoopNovoComentario,
    setCoopPlanos,
    setDriverSortMode,
    setEditandoMeta,
    setEditandoMetaEt,
    setEtapaDriversFilter,
    setEtapaHistSel,
    setEtapaSel,
    setEvaChatAtivoId,
    setEvaChats,
    setFiltroCidadeAberto,
    setFiltroResp,
    setFiltroSt,
    setGamificacaoOn,
    setHiddenLines,
    setHistoricoEvaVisivel,
    setMetaEtapa,
    setMetas,
    setMetasCardOpen,
    setMetasEtapas,
    setModal,
    setMostrarOcultos,
    setNotifFeedback,
    setNotifModalFiltro,
    setNotifModalOpen,
    setNotifOpen,
    setNotifs,
    setPB,
    setPD,
    setPE,
    setPJ,
    setPS,
    setPeriodoCustom,
    setPeriodoG,
    setPrefilledAcao,
    setRespDropOpen,
    setSegIndicador,
    setStDropOpen,
    setSucessoFiltroPeriodo,
    setSucessoModalOpen,
    setTab,
    setTipoBenefAberto,
    setTipoBeneficiario,
    setVerbatinsModal,
    stDropOpen,
    sucessoFiltroPeriodo,
    sucessoModalOpen,
    tab,
    tipoBenefAberto,
    tipoBeneficiario,
    todasCidades,
    toggleCidade,
    toggleComentarios,
    toggleCoopDriver,
    toggleCurtida,
    toggleLine,
    toggleSegHist,
  } = ctx;
  return (() => {
    // Lista completa de etapas/indicadores pra filtrar (não mais derivado só dos planos)
    const etapasCompletas = [
      { grupo: "indicadores", k: "NPS Geral" },
      { grupo: "indicadores", k: "CSAT Geral" },
      { grupo: "indicadores", k: "CES Geral" },
      { grupo: "indicadores", k: "Jornada CX Geral" },
      ...Object.keys(JCFG).map((e) => ({ grupo: "etapa", k: e })),
    ];
    // Filtra planos por busca + etapa + drivers
    const planosFiltrados = coopPlanos.filter((p) => {
      if (coopEtapaFilter !== "todas" && p.etapa !== coopEtapaFilter)
        return false;
      if (coopDriverFilter.size > 0) {
        // Plano precisa ter PELO MENOS um dos drivers filtrados
        const planDrivers = p.drivers || [];
        if (!planDrivers.some((d) => coopDriverFilter.has(d))) return false;
      }
      if (coopBusca.trim()) {
        const b = coopBusca.toLowerCase();
        return (
          p.titulo +
          " " +
          p.desc +
          " " +
          p.unimed +
          " " +
          (p.tags || []).join(" ")
        )
          .toLowerCase()
          .includes(b);
      }
      return true;
    });
    // Pool de "curtidores" pra efeito Instagram ("Curtido por X, Y e outros N")
    const CURTIDORES_POOL = [
      { nome: "Mariana Costa", unimed: "Unimed Goiânia" },
      { nome: "Roberto Tanaka", unimed: "Unimed Curitiba" },
      { nome: "Helena Ribeiro", unimed: "Unimed Brasília" },
      { nome: "Marcos Aurélio", unimed: "Unimed Brasília" },
      { nome: "Tânia Oliveira", unimed: "Unimed Santos" },
      { nome: "Paulo Almeida", unimed: "Unimed Ribeirão" },
      { nome: "Cristina Souza", unimed: "Unimed Uberlândia" },
      { nome: "Carlos Drummond", unimed: "Unimed Belo Horizonte" },
      { nome: "Beatriz Lopes", unimed: "Unimed Florianópolis" },
      { nome: "Felipe Andrade", unimed: "Unimed Maceió" },
      { nome: "Patrícia Vargas", unimed: "Unimed Manaus" },
      { nome: "Eduardo Nunes", unimed: "Unimed Natal" },
      { nome: "Joana Bittencourt", unimed: "Unimed João Pessoa" },
      { nome: "Rafael Moura", unimed: "Unimed Aracaju" },
      { nome: "Vanessa Lins", unimed: "Unimed Teresina" },
      { nome: "Sérgio Bastos", unimed: "Unimed Cuiabá" },
      { nome: "Letícia Marquez", unimed: "Unimed Campo Grande" },
      { nome: "Bruno Pacheco", unimed: "Unimed Vitória" },
      { nome: "Gabriela Saldanha", unimed: "Unimed São Luís" },
      { nome: "Henrique Albuquerque", unimed: "Unimed Palmas" },
      { nome: "Renato Andrade", unimed: "Unimed" },
      { nome: "Camila Pereira", unimed: "Unimed Sorocaba" },
    ];
    // Pega 2 curtidores estáveis por post (hash do id)
    const curtidoresDoPost = (id) => {
      let h = 0;
      for (let i = 0; i < id.length; i++) h = (h * 31 + id.charCodeAt(i)) >>> 0;
      const a = CURTIDORES_POOL[h % CURTIDORES_POOL.length];
      const b = CURTIDORES_POOL[(h * 7 + 13) % CURTIDORES_POOL.length];
      return a.nome === b.nome
        ? [a, CURTIDORES_POOL[(h + 1) % CURTIDORES_POOL.length]]
        : [a, b];
    };
    // Stats agregados
    const totalGanho = coopPlanos.reduce((s, p) => s + p.ganhoPp, 0);
    const totalUnimeds = new Set(coopPlanos.map((p) => p.unimed)).size;
    // Stats por Unimed: postados (count no feed) e realizados (mock: postados + offset estável,
    // exceto Unimed que usa o count real de ações concluídas internamente)
    const acoesConcluidasInternas = acoes.filter(
      (a) => a.status === "concluido",
    ).length;
    const acoesPostadasInternas = coopPlanos.filter(
      (p) => p.unimed === UNIMED,
    ).length;
    const unimedStats = {};
    coopPlanos.forEach((p) => {
      if (!unimedStats[p.unimed]) {
        // Hash simples pra gerar offset estável por Unimed (3-9 planos extras realizados internamente)
        let h = 0;
        for (let i = 0; i < p.unimed.length; i++)
          h = (h * 31 + p.unimed.charCodeAt(i)) >>> 0;
        unimedStats[p.unimed] = {
          postados: 0,
          realizadosOffset: 3 + (h % 7),
          totalGanho: 0,
        };
      }
      unimedStats[p.unimed].postados += 1;
      unimedStats[p.unimed].totalGanho += p.ganhoPp || 0;
    });
    Object.keys(unimedStats).forEach((u) => {
      if (u === UNIMED) {
        unimedStats[u].realizados = acoesConcluidasInternas;
        unimedStats[u].postados = acoesPostadasInternas;
      } else {
        unimedStats[u].realizados =
          unimedStats[u].postados + unimedStats[u].realizadosOffset;
      }
    });

    return (
      <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
        {/* Header do feed */}
        <Card
          style={{
            padding: "18px 22px",
            background: `linear-gradient(135deg,${C.g800} 0%,${C.g700} 100%)`,
            border: "none",
            color: "#FFFFFF",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
            <div
              style={{
                width: 52,
                height: 52,
                borderRadius: 14,
                background: "rgba(255,255,255,.15)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <Share2 size={24} color="#FFFFFF" />
            </div>
            <div style={{ flex: 1 }}>
              <div
                style={{
                  fontSize: 17,
                  fontWeight: 700,
                  letterSpacing: "-0.02em",
                }}
              >
                CooperAção Unimed — Feed de Planos Compartilhados
              </div>
              <div
                style={{
                  fontSize: 12,
                  color: "rgba(255,255,255,.7)",
                  marginTop: 2,
                }}
              >
                Feed de planos compartilhados. Veja o que está funcionando em
                outras Unimeds, curta, comente e reuse o que fizer sentido pra
                sua operação.
              </div>
            </div>
            <div style={{ display: "flex", gap: 18, flexShrink: 0 }}>
              <div style={{ textAlign: "center" }}>
                <div
                  style={{
                    fontSize: 22,
                    fontWeight: 700,
                    letterSpacing: "-0.03em",
                  }}
                >
                  {coopPlanos.length}
                </div>
                <div
                  style={{
                    fontSize: 9,
                    color: "rgba(255,255,255,.6)",
                    textTransform: "uppercase",
                    letterSpacing: "0.06em",
                  }}
                >
                  planos
                </div>
              </div>
              <div style={{ textAlign: "center" }}>
                <div
                  style={{
                    fontSize: 22,
                    fontWeight: 700,
                    letterSpacing: "-0.03em",
                  }}
                >
                  {totalUnimeds}
                </div>
                <div
                  style={{
                    fontSize: 9,
                    color: "rgba(255,255,255,.6)",
                    textTransform: "uppercase",
                    letterSpacing: "0.06em",
                  }}
                >
                  unimeds
                </div>
              </div>
              <div style={{ textAlign: "center" }}>
                <div
                  style={{
                    fontSize: 22,
                    fontWeight: 700,
                    letterSpacing: "-0.03em",
                    color: "#86EFAC",
                  }}
                >
                  +{totalGanho}pp
                </div>
                <div
                  style={{
                    fontSize: 9,
                    color: "rgba(255,255,255,.6)",
                    textTransform: "uppercase",
                    letterSpacing: "0.06em",
                  }}
                >
                  impacto total
                </div>
              </div>
            </div>
          </div>
        </Card>

        {/* Busca */}
        <div
          style={{
            display: "flex",
            gap: 10,
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              border: `1px solid ${C.border}`,
              borderRadius: 12,
              padding: "9px 14px",
              background: C.surface,
              flex: 1,
              minWidth: 240,
              maxWidth: 500,
            }}
          >
            <Search size={14} color={C.text4} />
            <input
              value={coopBusca}
              onChange={(e) => setCoopBusca(e.target.value)}
              placeholder="Buscar por título, Unimed ou tag..."
              style={{
                border: "none",
                outline: "none",
                fontSize: 13,
                background: "transparent",
                color: C.text,
                fontFamily: "inherit",
                flex: 1,
              }}
            />
          </div>
          <span style={{ fontSize: 11, color: C.text4, marginLeft: "auto" }}>
            {planosFiltrados.length} plano
            {planosFiltrados.length === 1 ? "" : "s"}
          </span>
        </div>

        {/* Filtro de etapas — linha 1: indicadores principais / linha 2: 11 etapas da jornada */}
        <Card style={{ padding: "12px 16px" }}>
          <div
            style={{
              fontSize: 10,
              fontWeight: 700,
              color: C.text4,
              textTransform: "uppercase",
              letterSpacing: "0.06em",
              marginBottom: 8,
              display: "flex",
              alignItems: "center",
              gap: 5,
            }}
          >
            <MapPin size={10} /> Filtrar por etapa / indicador
          </div>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: 5,
              alignItems: "center",
            }}
          >
            <button
              onClick={() => setCoopEtapaFilter("todas")}
              style={{
                padding: "5px 11px",
                borderRadius: 20,
                border: `1px solid ${coopEtapaFilter === "todas" ? C.g700 : C.border}`,
                background: coopEtapaFilter === "todas" ? C.g700 : C.surface,
                color: coopEtapaFilter === "todas" ? "#FFFFFF" : C.text2,
                fontSize: 10,
                fontWeight: 600,
                cursor: "pointer",
                fontFamily: "inherit",
              }}
            >
              Todas
            </button>
            <span
              style={{
                fontSize: 9,
                color: C.text4,
                fontWeight: 600,
                marginLeft: 6,
                marginRight: 2,
                textTransform: "uppercase",
                letterSpacing: "0.04em",
              }}
            >
              Indicadores:
            </span>
            {etapasCompletas
              .filter((e) => e.grupo === "indicadores")
              .map(({ k }) => (
                <button
                  key={k}
                  onClick={() =>
                    setCoopEtapaFilter(k === coopEtapaFilter ? "todas" : k)
                  }
                  style={{
                    padding: "5px 11px",
                    borderRadius: 20,
                    border: `1px solid ${coopEtapaFilter === k ? C.p500 : C.border}`,
                    background: coopEtapaFilter === k ? C.p500 : C.surface,
                    color: coopEtapaFilter === k ? "#FFFFFF" : C.text2,
                    fontSize: 10,
                    fontWeight: 600,
                    cursor: "pointer",
                    fontFamily: "inherit",
                  }}
                >
                  {k}
                </button>
              ))}
            <span
              style={{
                fontSize: 9,
                color: C.text4,
                fontWeight: 600,
                marginLeft: 8,
                marginRight: 2,
                textTransform: "uppercase",
                letterSpacing: "0.04em",
              }}
            >
              Etapas da jornada:
            </span>
            {etapasCompletas
              .filter((e) => e.grupo === "etapa")
              .map(({ k }) => (
                <button
                  key={k}
                  onClick={() =>
                    setCoopEtapaFilter(k === coopEtapaFilter ? "todas" : k)
                  }
                  style={{
                    padding: "5px 11px",
                    borderRadius: 20,
                    border: `1px solid ${coopEtapaFilter === k ? C.blue : C.border}`,
                    background: coopEtapaFilter === k ? C.blue : C.surface,
                    color: coopEtapaFilter === k ? "#FFFFFF" : C.text2,
                    fontSize: 10,
                    fontWeight: 600,
                    cursor: "pointer",
                    fontFamily: "inherit",
                  }}
                >
                  {k}
                </button>
              ))}
          </div>
        </Card>

        {/* Filtro de drivers */}
        <Card style={{ padding: "12px 16px" }}>
          <div
            style={{
              fontSize: 10,
              fontWeight: 700,
              color: C.text4,
              textTransform: "uppercase",
              letterSpacing: "0.06em",
              marginBottom: 8,
              display: "flex",
              alignItems: "center",
              gap: 5,
              justifyContent: "space-between",
            }}
          >
            <span style={{ display: "flex", alignItems: "center", gap: 5 }}>
              <Crosshair size={10} /> Filtrar por driver afetado
              {coopDriverFilter.size > 0 && (
                <span
                  style={{
                    background: C.purple || "#7C68EE",
                    color: "#FFFFFF",
                    borderRadius: 20,
                    padding: "1px 7px",
                    fontSize: 9,
                    fontWeight: 700,
                    marginLeft: 4,
                  }}
                >
                  {coopDriverFilter.size}
                </span>
              )}
            </span>
            {coopDriverFilter.size > 0 && (
              <button
                onClick={() => setCoopDriverFilter(new Set())}
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  fontSize: 9,
                  color: C.purple || "#7C68EE",
                  fontWeight: 700,
                  fontFamily: "inherit",
                  textTransform: "uppercase",
                  letterSpacing: "0.04em",
                }}
              >
                Limpar
              </button>
            )}
          </div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 5 }}>
            {DRIVERS_CANONICOS.map((drv) => {
              const active = coopDriverFilter.has(drv.slug);
              return (
                <button
                  key={drv.slug}
                  onClick={() => toggleCoopDriver(drv.slug)}
                  title={drv.desc}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 5,
                    padding: "5px 11px",
                    borderRadius: 20,
                    border: `1px solid ${active ? C.purple || "#7C68EE" : C.border}`,
                    background: active ? C.purpleBg || "#F0EDFF" : C.surface,
                    color: active ? C.purple || "#7C68EE" : C.text3,
                    fontSize: 10,
                    fontWeight: 600,
                    cursor: "pointer",
                    fontFamily: "inherit",
                  }}
                >
                  <span
                    style={{
                      fontSize: 12,
                      filter: active ? "none" : "grayscale(60%)",
                      opacity: active ? 1 : 0.7,
                    }}
                  >
                    {drv.icon}
                  </span>
                  {drv.label}
                </button>
              );
            })}
          </div>
        </Card>

        {/* Feed de planos */}
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {planosFiltrados.length === 0 && (
            <Card style={{ padding: "40px", textAlign: "center" }}>
              <div style={{ color: C.text4, fontSize: 13 }}>
                Nenhum plano encontrado com esses filtros.
              </div>
            </Card>
          )}
          {planosFiltrados.map((p) => {
            const curtido = coopCurtidas.has(p.id);
            const isNovo = p.unimed === UNIMED;
            return (
              <Card
                key={p.id}
                style={{
                  padding: "18px 22px",
                  border: `1px solid ${isNovo ? C.g300 : C.border}`,
                  background: isNovo
                    ? `linear-gradient(135deg,${C.greenBg} 0%,${C.surface} 30%)`
                    : C.surface,
                }}
              >
                {/* Header do post */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 12,
                    marginBottom: 12,
                  }}
                >
                  <div
                    style={{
                      width: 44,
                      height: 44,
                      borderRadius: "50%",
                      background: `linear-gradient(135deg,${C.g700},${C.g600})`,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                      fontSize: 22,
                      border: `2px solid ${C.surface}`,
                      boxShadow: "0 2px 8px rgba(0,0,0,.08)",
                    }}
                  >
                    {p.avatar}
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 6,
                        flexWrap: "wrap",
                      }}
                    >
                      <div
                        style={{
                          fontSize: 13,
                          fontWeight: 700,
                          color: C.text,
                          letterSpacing: "-0.01em",
                        }}
                      >
                        {p.unimed}
                      </div>
                      <div
                        style={{
                          fontSize: 10,
                          color: C.text4,
                          fontWeight: 500,
                          background: C.surf3,
                          padding: "1px 6px",
                          borderRadius: 4,
                        }}
                      >
                        {p.uf}
                      </div>
                      {p.verif && (
                        <div
                          title="Unimed verificada"
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <CheckCircle2 size={13} color={C.blue} />
                        </div>
                      )}
                      {isNovo && (
                        <div
                          style={{
                            fontSize: 9,
                            fontWeight: 700,
                            background: C.green,
                            color: "#FFFFFF",
                            padding: "2px 7px",
                            borderRadius: 20,
                          }}
                        >
                          NOVO · VOCÊ
                        </div>
                      )}
                      <div
                        style={{
                          fontSize: 10,
                          color: C.text4,
                          marginLeft: "auto",
                        }}
                      >
                        {fmtDt(p.postadoEm)}
                      </div>
                      {isNovo && (
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            if (
                              window.confirm(
                                `Remover este post do feed CooperAção?\n\n"${p.titulo}"\n\nOutras Unimeds não verão mais esse plano. Essa ação não pode ser desfeita.`,
                              )
                            ) {
                              setCoopPlanos((prev) =>
                                prev.filter((pp) => pp.id !== p.id),
                              );
                            }
                          }}
                          title="Apagar este post"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "transparent",
                            border: `1px solid ${C.border}`,
                            borderRadius: 6,
                            width: 24,
                            height: 22,
                            cursor: "pointer",
                            color: C.red,
                            fontFamily: "inherit",
                            padding: 0,
                            transition: "all .15s",
                          }}
                        >
                          <Trash2 size={11} />
                        </button>
                      )}
                    </div>
                    <div style={{ fontSize: 10, color: C.text4, marginTop: 2 }}>
                      {p.autor}
                    </div>
                    {/* Pills de contato — só aparecem se o autor preencheu telefone ou email ao publicar */}
                    {(p.telefone || p.email) && (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 6,
                          marginTop: 5,
                          flexWrap: "wrap",
                        }}
                      >
                        {p.telefone && (
                          <a
                            href={`tel:${p.telefone.replace(/\D/g, "")}`}
                            title={`Ligar para ${p.telefone}`}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 4,
                              padding: "3px 9px",
                              background: C.surf3,
                              border: `1px solid ${C.border}`,
                              borderRadius: 20,
                              fontSize: 10,
                              fontWeight: 600,
                              color: C.text3,
                              textDecoration: "none",
                              transition: "all .15s",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.background = C.greenBg;
                              e.currentTarget.style.borderColor = C.g300;
                              e.currentTarget.style.color = C.g700;
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.background = C.surf3;
                              e.currentTarget.style.borderColor = C.border;
                              e.currentTarget.style.color = C.text3;
                            }}
                          >
                            <Phone size={10} /> {p.telefone}
                          </a>
                        )}
                        {p.email && (
                          <a
                            href={`mailto:${p.email}?subject=${encodeURIComponent(`CooperAção Unimed — ${p.titulo}`)}`}
                            title={`Enviar e-mail para ${p.email}`}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 4,
                              padding: "3px 9px",
                              background: C.surf3,
                              border: `1px solid ${C.border}`,
                              borderRadius: 20,
                              fontSize: 10,
                              fontWeight: 600,
                              color: C.text3,
                              textDecoration: "none",
                              transition: "all .15s",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.background = C.greenBg;
                              e.currentTarget.style.borderColor = C.g300;
                              e.currentTarget.style.color = C.g700;
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.background = C.surf3;
                              e.currentTarget.style.borderColor = C.border;
                              e.currentTarget.style.color = C.text3;
                            }}
                          >
                            <Mail size={10} /> {p.email}
                          </a>
                        )}
                      </div>
                    )}
                    {/* Track record da Unimed: planos realizados internamente vs postados no feed vs impacto total */}
                    {unimedStats[p.unimed] && (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                          marginTop: 6,
                          flexWrap: "wrap",
                        }}
                      >
                        <div
                          title="Total de planos de ação concluídos internamente por esta Unimed"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 4,
                            padding: "2px 8px",
                            background: C.greenBg,
                            border: `1px solid ${C.g300}`,
                            borderRadius: 20,
                            fontSize: 9,
                            fontWeight: 700,
                            color: C.g700,
                          }}
                        >
                          <CheckCircle2 size={10} />{" "}
                          {unimedStats[p.unimed].realizados} realizados
                        </div>
                        <div
                          title="Total de planos que esta Unimed compartilhou no CooperAção"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 4,
                            padding: "2px 8px",
                            background: C.purpleBg || "#F0EDFF",
                            border: `1px solid ${C.purple || "#7C68EE"}30`,
                            borderRadius: 20,
                            fontSize: 9,
                            fontWeight: 700,
                            color: C.purple || "#7C68EE",
                          }}
                        >
                          <Share2 size={10} /> {unimedStats[p.unimed].postados}{" "}
                          postados
                        </div>
                        <div
                          title="Soma do impacto (em pp) de todos os planos que esta Unimed já compartilhou no CooperAção"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 4,
                            padding: "2px 8px",
                            background: "#FEF3C7",
                            border: `1px solid #FCD34D`,
                            borderRadius: 20,
                            fontSize: 9,
                            fontWeight: 700,
                            color: "#B45309",
                          }}
                        >
                          <TrendingUp size={10} /> +
                          {unimedStats[p.unimed].totalGanho}pp impacto
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* Título + descrição */}
                <div style={{ marginBottom: 12 }}>
                  <div
                    style={{
                      fontSize: 15,
                      fontWeight: 700,
                      color: C.text,
                      letterSpacing: "-0.02em",
                      marginBottom: 6,
                      lineHeight: 1.3,
                    }}
                  >
                    {p.titulo}
                  </div>
                  <div
                    style={{ fontSize: 12, color: C.text2, lineHeight: 1.55 }}
                  >
                    {p.desc}
                  </div>
                </div>

                {/* Etapa + drivers */}
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 5,
                    marginBottom: 12,
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      padding: "4px 10px",
                      borderRadius: 20,
                      background: C.blueBg,
                      border: `1px solid ${C.blue}40`,
                      fontSize: 10,
                      fontWeight: 600,
                      color: C.blue,
                      display: "flex",
                      alignItems: "center",
                      gap: 4,
                    }}
                  >
                    <MapPin size={10} /> {p.etapa}
                  </div>
                  {(p.drivers || []).map((slug) => {
                    const drv = getDriverInfo(slug);
                    if (!drv) return null;
                    return (
                      <div
                        key={slug}
                        title={drv.desc}
                        style={{
                          padding: "4px 10px",
                          borderRadius: 20,
                          background: C.purpleBg || "#F0EDFF",
                          border: `1px solid ${C.purple || "#7C68EE"}30`,
                          fontSize: 10,
                          fontWeight: 600,
                          color: C.purple || "#7C68EE",
                          display: "flex",
                          alignItems: "center",
                          gap: 3,
                        }}
                      >
                        <span style={{ fontSize: 11 }}>{drv.icon}</span>
                        {drv.label}
                      </div>
                    );
                  })}
                </div>

                {/* Stats do plano */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))",
                    gap: 8,
                    marginBottom: 12,
                    padding: "10px 14px",
                    background: C.surf3,
                    borderRadius: 10,
                    border: `1px solid ${C.border}`,
                  }}
                >
                  <div>
                    <div
                      style={{
                        fontSize: 9,
                        color: C.text4,
                        fontWeight: 600,
                        textTransform: "uppercase",
                        letterSpacing: "0.04em",
                      }}
                    >
                      Ganho reportado
                    </div>
                    <div
                      style={{
                        fontSize: 16,
                        fontWeight: 700,
                        color: C.green,
                        letterSpacing: "-0.02em",
                      }}
                    >
                      +{p.ganhoPp}pp
                    </div>
                  </div>
                  <div>
                    <div
                      style={{
                        fontSize: 9,
                        color: C.text4,
                        fontWeight: 600,
                        textTransform: "uppercase",
                        letterSpacing: "0.04em",
                      }}
                    >
                      Duração
                    </div>
                    <div
                      style={{ fontSize: 13, fontWeight: 700, color: C.text }}
                    >
                      {p.duracaoDias} dias
                    </div>
                  </div>
                  <div>
                    <div
                      style={{
                        fontSize: 9,
                        color: C.text4,
                        fontWeight: 600,
                        textTransform: "uppercase",
                        letterSpacing: "0.04em",
                      }}
                    >
                      Tarefas
                    </div>
                    <div
                      style={{ fontSize: 13, fontWeight: 700, color: C.text }}
                    >
                      {p.numTarefas}
                    </div>
                  </div>
                  <div>
                    <div
                      style={{
                        fontSize: 9,
                        color: C.text4,
                        fontWeight: 600,
                        textTransform: "uppercase",
                        letterSpacing: "0.04em",
                      }}
                    >
                      Responsáveis
                    </div>
                    <div
                      style={{
                        fontSize: 11,
                        fontWeight: 600,
                        color: C.text,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {(p.responsaveis || []).join(", ")}
                    </div>
                  </div>
                </div>

                {/* Tags */}
                {p.tags && p.tags.length > 0 && (
                  <div
                    style={{
                      display: "flex",
                      gap: 5,
                      flexWrap: "wrap",
                      marginBottom: 10,
                    }}
                  >
                    {p.tags.map((t) => (
                      <span
                        key={t}
                        style={{
                          fontSize: 9,
                          color: C.text3,
                          background: C.surf3,
                          padding: "2px 8px",
                          borderRadius: 20,
                          fontWeight: 500,
                        }}
                      >
                        #{t}
                      </span>
                    ))}
                  </div>
                )}

                {/* Curtido por (estilo Instagram) */}
                {(() => {
                  const totalCurt = p.curtidas + (curtido ? 1 : 0);
                  if (totalCurt === 0) return null;
                  const [c1, c2] = curtidoresDoPost(p.id);
                  const restante = Math.max(0, totalCurt - 2);
                  return (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        marginBottom: 10,
                        paddingTop: 8,
                        borderTop: `1px dashed ${C.border}`,
                      }}
                    >
                      {/* Mini-avatares empilhados */}
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <div
                          style={{
                            width: 20,
                            height: 20,
                            borderRadius: "50%",
                            background: `linear-gradient(135deg,${C.purple || "#7C68EE"},${C.p700 || "#6D5DD8"})`,
                            border: `2px solid ${C.surface}`,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#FFFFFF",
                            fontSize: 9,
                            fontWeight: 700,
                            zIndex: 2,
                          }}
                        >
                          {c1.nome[0]}
                        </div>
                        <div
                          style={{
                            width: 20,
                            height: 20,
                            borderRadius: "50%",
                            background: `linear-gradient(135deg,${C.blue},#3B82F6)`,
                            border: `2px solid ${C.surface}`,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#FFFFFF",
                            fontSize: 9,
                            fontWeight: 700,
                            marginLeft: -7,
                            zIndex: 1,
                          }}
                        >
                          {c2.nome[0]}
                        </div>
                      </div>
                      <div
                        style={{
                          fontSize: 11,
                          color: C.text3,
                          lineHeight: 1.4,
                        }}
                      >
                        Curtido por{" "}
                        <b style={{ color: C.text }}>
                          {c1.nome.split(" ")[0]} da {c1.unimed}
                        </b>
                        ,{" "}
                        <b style={{ color: C.text }}>
                          {c2.nome.split(" ")[0]} da {c2.unimed}
                        </b>
                        {restante > 0 && (
                          <>
                            {" "}
                            e outr{restante === 1 ? "o" : "os"}{" "}
                            <b style={{ color: C.text }}>{restante}</b>
                          </>
                        )}
                      </div>
                    </div>
                  );
                })()}

                {/* Interaction bar */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 18,
                    paddingTop: 10,
                    borderTop: `1px solid ${C.border}`,
                  }}
                >
                  <button
                    onClick={() => toggleCurtida(p.id)}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 5,
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      color: curtido ? C.red : C.text3,
                      fontSize: 11,
                      fontWeight: 600,
                      fontFamily: "inherit",
                      padding: 0,
                      transition: "all .15s",
                    }}
                  >
                    <Heart size={14} fill={curtido ? C.red : "none"} />
                    {p.curtidas + (curtido ? 1 : 0)}
                  </button>
                  <button
                    onClick={() => toggleComentarios(p.id)}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 5,
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      color: coopComentariosAbertos.has(p.id)
                        ? C.blue
                        : C.text3,
                      fontSize: 11,
                      fontWeight: 600,
                      fontFamily: "inherit",
                      padding: 0,
                      transition: "all .15s",
                    }}
                  >
                    <MessageCircle size={14} />
                    {(p.comentariosLista || []).length}
                  </button>
                  <button
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 5,
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      color: C.text3,
                      fontSize: 11,
                      fontWeight: 600,
                      fontFamily: "inherit",
                      padding: 0,
                    }}
                  >
                    <Share2 size={14} />
                    {p.reusos} reusos
                  </button>
                  <button
                    title="Reusar este plano na minha operação"
                    style={{
                      marginLeft: "auto",
                      display: "flex",
                      alignItems: "center",
                      gap: 5,
                      background: C.g700,
                      color: "#FFFFFF",
                      border: "none",
                      borderRadius: 8,
                      padding: "6px 12px",
                      cursor: "pointer",
                      fontSize: 10,
                      fontWeight: 700,
                      fontFamily: "inherit",
                    }}
                  >
                    <Upload size={12} /> Reusar este plano
                  </button>
                </div>

                {/* Seção de comentários (expansível) */}
                {coopComentariosAbertos.has(p.id) && (
                  <div
                    style={{
                      marginTop: 12,
                      paddingTop: 12,
                      borderTop: `1px solid ${C.border}`,
                    }}
                  >
                    <div
                      style={{
                        fontSize: 10,
                        fontWeight: 700,
                        color: C.text4,
                        textTransform: "uppercase",
                        letterSpacing: "0.06em",
                        marginBottom: 10,
                        display: "flex",
                        alignItems: "center",
                        gap: 5,
                      }}
                    >
                      <MessageCircle size={10} /> Comentários ·{" "}
                      {(p.comentariosLista || []).length}
                    </div>
                    {/* Lista de comentários existentes */}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 10,
                        marginBottom: 12,
                        maxHeight: 280,
                        overflowY: "auto",
                      }}
                    >
                      {(p.comentariosLista || []).length === 0 && (
                        <div
                          style={{
                            fontSize: 11,
                            color: C.text4,
                            fontStyle: "italic",
                            textAlign: "center",
                            padding: "12px 0",
                          }}
                        >
                          Seja o primeiro a comentar neste plano.
                        </div>
                      )}
                      {(p.comentariosLista || []).map((cmt) => (
                        <div
                          key={cmt.id}
                          style={{
                            display: "flex",
                            gap: 10,
                            alignItems: "flex-start",
                          }}
                        >
                          <div
                            style={{
                              width: 32,
                              height: 32,
                              borderRadius: "50%",
                              background: `linear-gradient(135deg,${C.g700},${C.g600})`,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexShrink: 0,
                              fontSize: 16,
                              border: `2px solid ${C.surface}`,
                              boxShadow: "0 1px 4px rgba(0,0,0,.08)",
                            }}
                          >
                            {cmt.avatar}
                          </div>
                          <div
                            style={{
                              flex: 1,
                              minWidth: 0,
                              background: C.surf3,
                              borderRadius: 10,
                              padding: "8px 12px",
                              border: `1px solid ${C.border}`,
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "baseline",
                                gap: 6,
                                flexWrap: "wrap",
                                marginBottom: 3,
                              }}
                            >
                              <span
                                style={{
                                  fontSize: 11,
                                  fontWeight: 700,
                                  color: C.text,
                                  letterSpacing: "-0.01em",
                                }}
                              >
                                {cmt.unimed}
                              </span>
                              <span
                                style={{
                                  fontSize: 9,
                                  color: C.text4,
                                  fontWeight: 500,
                                }}
                              >
                                {cmt.autor}
                              </span>
                              <span
                                style={{
                                  fontSize: 9,
                                  color: C.text4,
                                  marginLeft: "auto",
                                }}
                              >
                                {fmtDt(cmt.dt)}
                              </span>
                            </div>
                            <div
                              style={{
                                fontSize: 11,
                                color: C.text2,
                                lineHeight: 1.5,
                              }}
                            >
                              {cmt.texto}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                    {/* Input pra novo comentário */}
                    <div
                      style={{
                        display: "flex",
                        gap: 8,
                        alignItems: "center",
                        background: C.surface,
                        border: `1.5px solid ${C.g300}`,
                        borderRadius: 12,
                        padding: "6px 6px 6px 14px",
                      }}
                    >
                      <div
                        style={{
                          width: 26,
                          height: 26,
                          borderRadius: "50%",
                          background: `linear-gradient(135deg,${C.g700},${C.g600})`,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexShrink: 0,
                          fontSize: 13,
                        }}
                      >
                        🌱
                      </div>
                      <input
                        value={coopNovoComentario[p.id] || ""}
                        onChange={(e) =>
                          setCoopNovoComentario((prev) => ({
                            ...prev,
                            [p.id]: e.target.value,
                          }))
                        }
                        onKeyDown={(e) =>
                          e.key === "Enter" && adicionarComentario(p.id)
                        }
                        placeholder="Escreva um comentário..."
                        style={{
                          flex: 1,
                          border: "none",
                          outline: "none",
                          fontSize: 12,
                          background: "transparent",
                          color: C.text,
                          fontFamily: "inherit",
                        }}
                      />
                      <button
                        onClick={() => adicionarComentario(p.id)}
                        disabled={!(coopNovoComentario[p.id] || "").trim()}
                        style={{
                          background: (coopNovoComentario[p.id] || "").trim()
                            ? C.g700
                            : C.border,
                          color: "#FFFFFF",
                          border: "none",
                          borderRadius: 8,
                          padding: "6px 12px",
                          cursor: (coopNovoComentario[p.id] || "").trim()
                            ? "pointer"
                            : "default",
                          fontSize: 10,
                          fontWeight: 700,
                          fontFamily: "inherit",
                          display: "flex",
                          alignItems: "center",
                          gap: 4,
                        }}
                      >
                        <Send size={11} /> Publicar
                      </button>
                    </div>
                  </div>
                )}
              </Card>
            );
          })}
        </div>
      </div>
    );
  })();
}
